import { connect } from 'react-redux'
import {
  selectCcVisible,
  selectBccVisible,
  selectFromVisible,
  selectSubjectVisible,
  selectLastVisible,
} from 'selectors/reply_form'

import Expanded from './view'

const select = state => {
  return {
    ccVisible: selectCcVisible(state),
    bccVisible: selectBccVisible(state),
    fromVisible: selectFromVisible(state),
    subjectVisible: selectSubjectVisible(state),
    focusField: selectLastVisible(state),
  }
}

export default connect(select, null)(Expanded)
